"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverNavigation = exports.PopoverMobileContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _index2 = require("../TypeList/index.js");
var _PopoverDesktop = require("./PopoverDesktop.js");
var _PopoverMobile = require("./PopoverMobile.js");
var _excluded = ["colorSet", "className", "isMobile", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PopoverMobileContext = exports.PopoverMobileContext = /*#__PURE__*/(0, _react.createContext)({
  isMobile: false
});
function PopoverNavigationComponent(_ref) {
  var _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
    className = _ref.className,
    isMobile = _ref.isMobile,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var Popover = isMobile ? _PopoverMobile.PopoverMobile : _PopoverDesktop.PopoverDesktop;
  return /*#__PURE__*/_react["default"].createElement(Popover, Object.assign({
    className: (0, _index.addColorSet)(colorSet, className),
    $colorSet: colorSet
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.PopoverNavigation
  }), /*#__PURE__*/_react["default"].createElement(_index2.TypeList, {
    condensedAll: true,
    listStyleReset: true
  }, /*#__PURE__*/_react["default"].createElement(PopoverMobileContext.Provider, {
    value: {
      isMobile: !!isMobile
    }
  }, children)));
}
var popoverNavigationHelpers = _objectSpread({}, _index.deprecatedOverlayDirections);

/**
 * A popover that renders a simple list of PopoverNavigationLinks.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-popovernavigation--docs) |
 * [Encore site](https://encore.spotify.net/web/components/popover#navigation-popover) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PopoverNavigation) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12481&t=p9BSbkCzNpWDGLQr-1)
 */
var PopoverNavigation = exports.PopoverNavigation = Object.assign(PopoverNavigationComponent, popoverNavigationHelpers);